import { gql } from '@efficiently/client-core-graphql-models';

export const SELECT_PARSER_TEXT = gql(`
	query SelectParserText($args: SelectParserTextInput!) {
		selectParserText(args: $args) {
			entries {
				...ParserTextEntryFields
			}
		}
	}
`);
